export const SERVER_URL: string =
    process.env.REACT_APP_SERVER_URL || "https://api.requesta.app";

export const GOOGLE_CLIENT_ID: string =
    (process.env.REACT_APP_GOOGLE_CLIENT_ID as string) || "";
